<script>
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      'Binary': 'Binário',
      'Left': 'Esquerdo',
      'Right': 'Direito',
      'Smaller': 'Menor',
      'Spillover Side': 'Lado de Derramamento',
      'Choose a side': 'Escolha um lado',
      'Left Side': 'Lado Esquerdo',
      'Right Side': 'Lado Direito',
      'Smaller Side': 'Lado Menor',
      'Save': 'Salvar',
      'Products Vertical': 'Vertical de Produtos',
      'Services Vertical': 'Vertical de Serviços',
      'Total binary bonus': 'Bônus binário total',
      'Products': 'Produtos',
      'Services': 'Serviços',
      'Cycle closes in': 'Fechamento do ciclo em',
      'of the period': 'do período',
      'Coefficient': 'Coeficiente',
      'Percent': 'Porcentagem',
      'Smaller leg': 'Equipe menor',
      'Bonus': 'Bônus',
      'Qualified': 'Qualificado',
      'Not qualified': 'Não qualificado',
      'The spillover side has been successfully changed!': 'O lado de derramamento foi alterado com sucesso!',
    },
    es: {
      'Binary': 'Binario',
      'Left': 'Izquierdo',
      'Right': 'Derecho',
      'Smaller': 'Menor',
      'Spillover Side': 'Lado de Desbordamiento',
      'Choose a side': 'Elige un lado',
      'Left Side': 'Lado Izquierdo',
      'Right Side': 'Lado Derecho',
      'Smaller Side': 'Lado Menor',
      'Save': 'Guardar',
      'Products Vertical': 'Vertical de Productos',
      'Services Vertical': 'Vertical de Servicios',
      'Total binary bonus': 'Bono binario total',
      'Products': 'Productos',
      'Services': 'Servicios',
      'Cycle closes in': 'Cierre del ciclo en',
      'of the period': 'del período',
      'Coefficient': 'Coeficiente',
      'Percent': 'Porcentaje',
      'Smaller leg': 'Pierna menor',
      'Bonus': 'Bono',
      'Qualified': 'Calificado',
      'Not qualified': 'No calificado',
      'The spillover side has been successfully changed!': '¡El lado de desbordamiento ha sido cambiado con éxito!',
    }
  },
  data() {
    return {
      binaryClock: {
        timer: null,
        percent: 0,
        countdown: { hours: 0, minutes: 0, seconds: 0 },
      },

      binary: {
        modal: false,
        loading: false,
        side: "",

        status: "inactive",

        products: {
          points: {
            left: "-",
            right: "-",
          },
          percent: "-%",
          perpoint: "R$ -,--",
          bonus: "R$ -,--",
          raw: { left: 0, right: 0, bonus: 0 },
        },
        services: {
          points: {
            left: "-",
            right: "-",
          },
          percent: "-%",
          perpoint: "R$ -,--",
          bonus: "R$ -,--",
          raw: { left: 0, right: 0, bonus: 0 },
        },
      },
    };
  },
  computed: {
    // Soma dos bônus das duas verticais
    totalBonus() {
      return this.$options.filters.currency(this.binary.products.raw.bonus + this.binary.services.raw.bonus);
    },
    // Rótulo do lado de derramamento
    sideLabel() {
      return { l: 'Left', r: 'Right', m: 'Smaller' }[this.binary.side] || '';
    },
  },
  methods: {
    // Largura da barra da perna (a maior perna ocupa 100%)
    legPercent(vertical, side) {
      const raw = this.binary[vertical].raw;
      const max = Math.max(raw.left, raw.right);
      return max > 0 ? (raw[side] / max) * 100 : 0;
    },
    // Equipe menor da vertical
    smallerLeg(vertical) {
      const raw = this.binary[vertical].raw;
      if (raw.left <= 0 && raw.right <= 0) return '-';
      return this.t(raw.left <= raw.right ? 'Left' : 'Right');
    },
    getBinaryResume() {
      api
        .get('network/binary')
        .then(response => {
          if (response.data.status == 'success') {
            const resume = response.data.resume;

            // Qualificado se qualquer vertical estiver ativa
            this.binary.status = (resume.products.status == 'active' || resume.services.status == 'active') ? 'active' : 'inactive';

            ['products', 'services'].forEach(vertical => {
              this.binary[vertical].points.left = this.$options.filters.points(resume[vertical].points.left);
              this.binary[vertical].points.right = this.$options.filters.points(resume[vertical].points.right);
              this.binary[vertical].percent = resume[vertical].percent;
              this.binary[vertical].perpoint = this.$options.filters.currency(resume[vertical].perpoint);
              this.binary[vertical].bonus = this.$options.filters.currency(resume[vertical].bonus);
              this.binary[vertical].raw = {
                left: Number(resume[vertical].points.left) || 0,
                right: Number(resume[vertical].points.right) || 0,
                bonus: Number(resume[vertical].bonus) || 0,
              };
            });
          }
        })
    },
    getBinarySide() {
      api
        .get('network/binary/side')
        .then(response => {
          if (response.data.status == 'success') {
            this.binary.side = response.data.side
          }
        })
    },
    changeBinarySide() {
      this.binary.modal = false;
      this.binary.modal = true;
      this.binary.loading = false;
    },
    // Contador até meia-noite no horário de Miami (America/New_York)
    initBinaryMidnightClock() {
      if (this.binaryClock.timer) {
        clearInterval(this.binaryClock.timer)
        this.binaryClock.timer = null
      }
      const tick = () => {
        const miamiFormatter = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/New_York',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          hour12: false,
        })
        const parts = miamiFormatter.formatToParts(new Date())
        const get = (type) => parseInt(parts.find(p => p.type === type).value, 10)
        const hour = get('hour'), minute = get('minute'), second = get('second')

        // Segundos decorridos desde meia-noite em Miami
        const elapsedSeconds = hour * 3600 + minute * 60 + second
        const daySeconds = 86400
        const remainingSeconds = daySeconds - elapsedSeconds

        this.binaryClock.percent = Math.min(100, (elapsedSeconds / daySeconds) * 100)

        const hours = Math.floor(remainingSeconds / 3600)
        const minutes = Math.floor((remainingSeconds % 3600) / 60)
        const seconds = remainingSeconds % 60
        this.binaryClock.countdown = { hours, minutes, seconds }
      }
      tick()
      this.binaryClock.timer = setInterval(tick, 1000)
    },
    saveBinarySide() {
      this.binary.loading = true;

      api
        .post('network/binary/side', {
          side: this.binary.side
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.binary.modal = false;
            this.binary.loading = false;
            this.$toast.success(this.t('The spillover side has been successfully changed!'))
            this.getBinarySide();
          }
        })
        .finally(() => {
          this.binary.loading = false;
        })
    }
  },
  mounted() {
    this.getBinaryResume()
    this.getBinarySide()
    this.initBinaryMidnightClock()
  },
  beforeDestroy() {
    if (this.binaryClock.timer) {
      clearInterval(this.binaryClock.timer)
      this.binaryClock.timer = null
    }
  },
};
</script>

<template>
  <div>
    <fieldset class="binary">
      <legend>
        {{ t('Binary') }}
      </legend>

      <header class="binary-head">
        <div class="binary-head-right">
          <span class="binary-badge" :class="{ 'is-active': binary.status == 'active' }">
            {{ binary.status == 'active' ? t('Qualified') : t('Not qualified') }}
          </span>
          <button type="button" class="binary-config" v-on:click="changeBinarySide()">
            <span class="side">{{ sideLabel ? t(sideLabel) : '...' }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"></path>
            </svg>
          </button>
        </div>
      </header>

      <div class="binary-summary">
        <div>
          <div class="binary-summary-label">{{ t('Total binary bonus') }}</div>
          <div class="binary-summary-value">{{ totalBonus }}</div>
          <div class="binary-summary-sub">
            {{ t('Products') }} {{ binary.products.bonus }} · {{ t('Services') }} {{ binary.services.bonus }}
          </div>
        </div>
        <div class="binary-timer">
          <div class="binary-timer-top">
            {{ t('Cycle closes in') }}
            {{ Math.round(binaryClock.percent) }}%
            {{ t('of the period') }}
          </div>
          <div class="binary-midnight-countdown">
            <div class="binary-midnight-box">
              <span class="binary-midnight-num">{{ String(binaryClock.countdown.hours).padStart(2, '0') }}</span>
              <span class="binary-midnight-label">H</span>
            </div>
            <div class="binary-midnight-box">
              <span class="binary-midnight-num">{{ String(binaryClock.countdown.minutes).padStart(2, '0') }}</span>
              <span class="binary-midnight-label">M</span>
            </div>
            <div class="binary-midnight-box">
              <span class="binary-midnight-num">{{ String(binaryClock.countdown.seconds).padStart(2, '0') }}</span>
              <span class="binary-midnight-label">S</span>
            </div>
          </div>
          <div class="binary-midnight-progress__track">
            <div class="binary-midnight-progress__fill" :style="{ width: binaryClock.percent + '%' }"></div>
          </div>
        </div>
      </div>

      <div class="binary-grid">
        <article v-for="vertical in ['products', 'services']" :key="vertical" class="binary-vcard">
          <h6 class="binary-vtitle">
            {{ vertical == 'products' ? t('Products Vertical') : t('Services Vertical') }}
          </h6>

          <div class="binary-legs">
            <div class="binary-leg" v-for="side in ['left', 'right']" :key="side">
              <div class="binary-leg-name">
                <i class="binary-dot" :class="'is-' + side"></i>{{ side == 'left' ? t('Left') : t('Right') }}
              </div>
              <div class="binary-leg-track">
                <i :class="'is-' + side" :style="{ width: legPercent(vertical, side) + '%' }"></i>
              </div>
              <div class="binary-leg-val">{{ binary[vertical].points[side] }}</div>
            </div>
          </div>

          <div class="binary-metrics">
            <div><span>{{ t('Coefficient') }}</span><b>1 PV = {{ binary[vertical].perpoint }}</b></div>
            <div><span>{{ t('Percent') }}</span><b>{{ binary[vertical].percent }}</b></div>
            <div><span>{{ t('Smaller leg') }}</span><b>{{ smallerLeg(vertical) }}</b></div>
          </div>

          <div class="binary-bonus">
            <span>{{ t('Bonus') }}</span>
            <b>{{ binary[vertical].bonus }}</b>
          </div>
        </article>
      </div>
    </fieldset>

    <b-modal v-model="binary.modal" :title="t('Spillover Side')" modal-class="modal-right" hide-footer>
      <b-form @submit.prevent="saveBinarySide()">
        <b-form-group :label="t('Choose a side')" label-for="binary.side">
          <select v-model="binary.side" class="custom-select mb-2">
            <option value="l">{{ t('Left Side') }}</option>
            <option value="r">{{ t('Right Side') }}</option>
            <option value="m">{{ t('Smaller Side') }}</option>
          </select>
        </b-form-group>
        <b-button class="mb-0" :disabled="this.binary.loading" type="submit" variant="default" size="lg">
          {{ t('Save') }}
          <b-spinner v-if="binary.loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
        </b-button>
      </b-form>
    </b-modal>
  </div>
</template>
